import Languages from "../components/Languages";

function Home() {
  return <Languages />;
}

export default Home;
